import { Link } from "react-router-dom"

const AccountVerified = () => {
    return (
        <div className="d-flex justify-content-center align-items-center fill-page">
            <div className="alert alert-success alert-lg text-center">
                <img className="alert-icon" src={"/icons/check-circle.svg"} />
                <h1 className="alert-title text-center">Account verified</h1>
                <p className="text-center">Your account is now activated</p>
                <Link to={'/'} className={"btn btn-lg btn-black"}>Go to homepage</Link>
            </div>
        </div>
    )
}

export { AccountVerified }